export default "__VITE_ASSET__BQaZqaZt__"